import { useEffect } from 'react';

/** Keeps the current page's sidebar item visible when the menu is taller than the screen. The menu loads after
 *  the page, so this waits (up to 3 seconds) for the active item to appear. */
export const useActiveNavInView = (pathname: string) => {
  useEffect(() => {
    let tries = 0;
    let timer = 0;
    const reveal = () => {
      const item = document.querySelector('.sidebar-scroll .nav-item.active');
      if (item) item.scrollIntoView({ block: 'nearest' });
      else if (tries++ < 30) timer = window.setTimeout(reveal, 100);
    };
    reveal();
    return () => window.clearTimeout(timer);
  }, [pathname]);
};
